import React from 'react'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import LoadingButton from "../LoadingButton";
import removeClientAddressMutation from '../../../queries/server/mutations/remove_client_addresses'
import editClientLocalMutation from '../../../queries/client_side/mutations/edit_client'

const ClientLocationItem = ({client_id, address_id, address}) => {

    return (
        <Mutation mutation={removeClientAddressMutation}>
            {(removeClientAddressMutationFunc, {loading}) => (
                <Mutation mutation={editClientLocalMutation}>
                    {(editClientLocalMutationFunc) => (
                        <div className="d-flex flex-row align-items-center border-bottom p-2">
                            <FontAwesomeIcon color="#82ca9d" icon="map-marker-alt"/>
                            <p className="font-weight-light p-0 m-0 pl-2" style={{flex: 1}}>{address}</p>
                            <LoadingButton
                                size="sm"
                                color="danger"
                                icon="trash-alt"
                                loading={loading}
                                onClick={() => {
                                    removeClientAddressMutationFunc({variables: {client_id, ids: [address_id]}})
                                        .then(({data}) => {
                                            editClientLocalMutationFunc({variables: {data: data.removeClientAddresses}})
                                            toast.success('Location Removed', {autoClose: 2000})
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            />
                        </div>
                    )}

                </Mutation>
            )}

        </Mutation>
    )

}

ClientLocationItem.propTypes = {
    client_id: PropTypes.number.isRequired,
    address_id: PropTypes.number.isRequired,
    address: PropTypes.string.isRequired
}

export default ClientLocationItem